import React, { useState, useEffect } from 'react';
import './Accordion.styles.scss';
import Icon from '../Icon/Icon';

interface AccordionProps {
  headline: React.ReactNode;
  icon?: string;
  className?: string;
  children: React.ReactNode;
  isOpen?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  headline,
  className = '',
  children,
  isOpen,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(isOpen || false);
  }, [isOpen]);

  const toggleAccordion = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;
    if (!target.closest('.accordion-content__inner')) {
      setIsExpanded((prev) => !prev);
    }
  };

  return (
    <div className={`accordion ${isExpanded ? 'open' : ''} ${className}`}>
      <div className="accordion-header" onClick={toggleAccordion}>
        <div className="headline">{headline}</div>
        <Icon className="open" icon="add" />
        <Icon className="close" icon="remove" />
      </div>
      <div className="accordion-content">
        <div className="accordion-content__inner">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
